import { REACT_QUERY_KEYS } from '@/constants'

export const partnersQueryKeys = {
  all: [REACT_QUERY_KEYS.PARTNERS] as const,
  detail: (tenantKey: string, partnerId: number) =>
    [...partnersQueryKeys.all, 'detail', tenantKey, partnerId] as const,
  select: (tenantKey: string, dcId?: number) =>
    [...partnersQueryKeys.all, 'select', tenantKey, dcId] as const,
  inHouse: (tenantKey: string, dcId: number) =>
    [...partnersQueryKeys.all, 'in-house', tenantKey, dcId] as const
}
